import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const WarningBanner = styled(Box)`
  ${() => css`
    width: 100%;
    padding: 12px 16px;
    background-color: #fffbeb;
    border: 1px solid #f59e0b;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
  `}
`

export const WarningIconContainer = styled(Box)`
  flex-shrink: 0;
  margin-top: 2px;

  svg {
    color: #f59e0b;
    width: 22px;
    height: 19px;
  }
`

export const WarningText = styled.p`
  ${({ theme }) => css`
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: #92400e;
    line-height: 1.5;
    font-family: ${theme.fontFamily.openSans}, sans-serif;
  `}
`
